// English content — mirrors the approved master prompt copy.
export default {
  nav: {
    links: ["Home", "Website Demos", "Why Website?", "Services", "Pricing", "How It Works", "About", "Contact"],
    cta: "Get My Website",
    whatsapp: "WhatsApp Disign Digital",
  },
  hero: {
    eyebrow: "Professional Websites for Local Businesses",
    titleA: "Your Business Deserves to Be",
    titleB: "Online.",
    sub: "Get a professional website designed for your business — so customers can discover you, trust you and contact you.",
    ctaDemos: "Explore Website Demos",
    ctaWhats: "WhatsApp Us",
    location: "Built for local businesses across South India.",
    talk: "Talk to Anjum Kauser — Business Growth Expert",
    demoTag: "Website Demo",
    browserUrl: "yourbusiness.com",
    starting: "Websites starting at ₹4,999",
    startingTag: "We build. You grow.",
  },
  showroom: {
    eyebrow: "Website Demo Showroom",
    title: "See What Your Business Could Look Like Online",
    sub: "Choose your industry and explore a website designed specifically for your type of business.",
    filters: ["All", "Retail", "Food & Hospitality", "Healthcare", "Professional Services", "Auto & Home", "Education", "Beauty & Lifestyle"],
    live: "Live Demo",
    onRequest: "Demo on Request",
    explore: "Explore Demo Website",
    request: "Request This Demo",
    otherPre: "Don't see your industry?",
    otherLink: "Tell us on WhatsApp",
    otherPost: "— we build for every local business.",
  },
  industries: [
    { name: "Tyre & Auto Care", blurb: "Tyres, alignment, balancing & auto care" },
    { name: "Car Dealer", blurb: "New & used cars with easy enquiries" },
    { name: "Restaurant & Café", blurb: "Menu, specials & WhatsApp ordering" },
    { name: "Hotel & Resort", blurb: "Rooms, amenities & booking enquiries" },
    { name: "Dental Clinic", blurb: "Treatments, doctors & appointments" },
    { name: "Clinic & Healthcare", blurb: "Services, timings & patient enquiries" },
    { name: "Salon & Beauty", blurb: "Services, packages & bookings" },
    { name: "Gym & Fitness", blurb: "Memberships, trainers & schedules" },
    { name: "Interior Designer", blurb: "Portfolio, projects & consultations" },
    { name: "Builder & Contractor", blurb: "Projects, properties & enquiries" },
    { name: "Tuition & Coaching", blurb: "Courses, results & admissions" },
    { name: "Lawyer & CA", blurb: "Services, credentials & consultations" },
    { name: "Jewellery", blurb: "Collections, bridal & enquiries" },
    { name: "Boutique & Fashion", blurb: "Collections, offers & orders" },
    { name: "Photography", blurb: "Portfolio, packages & bookings" },
    { name: "Wedding & Events", blurb: "Services, gallery & enquiries" },
    { name: "Furniture Store", blurb: "Catalogue, offers & enquiries" },
    { name: "Home Services", blurb: "Services, areas & quick bookings" },
    { name: "Packers & Movers", blurb: "Quotes, services & tracking info" },
    { name: "Pet Care", blurb: "Grooming, boarding & appointments" },
  ],
  why: {
    eyebrow: "Why Website?",
    title: "Your Customers Are Already Searching.",
    sub: "Every day, people near you search for the exact services you offer. A website helps them find you, trust you and contact you.",
    cards: [
      { title: "Customers Search Before They Visit", desc: "People look up businesses on Google before calling or visiting. A website makes sure they find you." },
      { title: "Build Trust Before the First Call", desc: "A professional website shows you are a serious, established business — before anyone even speaks to you." },
      { title: "Show Everything in One Place", desc: "Your services, prices, photos, timings and location — all organised on one page you control." },
      { title: "Make Enquiries Easier", desc: "One tap to call or WhatsApp you. The easier it is to reach you, the more enquiries you get." },
      { title: "Your Business Works 24/7", desc: "Even when your shop is closed, your website keeps showing your business to new customers." },
    ],
  },
  who: {
    eyebrow: "Who Needs a Website?",
    title: "Is Your Business Ready for Its Own Website?",
    sub: "If customers search for what you do, a professional website helps them choose you.",
    cards: [
      { name: "Restaurants", benefit: "Show your menu and take orders on WhatsApp." },
      { name: "Hotels", benefit: "Display rooms and get direct booking enquiries." },
      { name: "Clinics", benefit: "Share services, timings and appointment options." },
      { name: "Dentists", benefit: "Explain treatments and let patients book visits." },
      { name: "Salons", benefit: "List services, prices and take bookings online." },
      { name: "Gyms", benefit: "Show memberships, trainers and class schedules." },
      { name: "Tyre Shops", benefit: "Display brands, services and get enquiries." },
      { name: "Auto Workshops", benefit: "List services and build trust with photos." },
      { name: "Car Dealers", benefit: "Showcase every car with photos and prices." },
      { name: "Interior Designers", benefit: "Turn your portfolio into new projects." },
      { name: "Builders", benefit: "Present projects professionally to buyers." },
      { name: "Real Estate", benefit: "Show properties and collect enquiries 24/7." },
      { name: "Lawyers", benefit: "Explain your practice areas and build credibility." },
      { name: "CA & Consultants", benefit: "List services and win clients' trust early." },
      { name: "Tuition Centres", benefit: "Show courses, results and admissions info." },
      { name: "Photographers", benefit: "Let your portfolio win you more bookings." },
      { name: "Wedding Businesses", benefit: "Show your work and get event enquiries." },
      { name: "Jewellers", benefit: "Display collections and get WhatsApp enquiries." },
      { name: "Boutiques", benefit: "Show new arrivals and take custom orders." },
      { name: "Furniture Stores", benefit: "Present your catalogue beyond the showroom." },
      { name: "Home Services", benefit: "Get found locally and receive quick bookings." },
    ],
  },
  services: {
    eyebrow: "Services",
    title: "More Than Just a Website",
    sub: "Everything your business needs to build a strong, professional digital presence.",
    items: [
      { title: "Business Website", desc: "A complete professional website that presents your business beautifully." },
      { title: "Local Business Website", desc: "Built to be found by customers in your area searching for your services." },
      { title: "Catalogue Website", desc: "Showcase your full range of products or services with photos and details." },
      { title: "Lead Generation Website", desc: "Designed to turn visitors into enquiries through forms, calls and WhatsApp." },
      { title: "Appointment / Booking Website", desc: "Let customers book appointments or slots directly from your website." },
      { title: "Google Business Profile Support", desc: "Help setting up and improving your Google Business Profile." },
      { title: "WhatsApp Integration", desc: "One-tap WhatsApp buttons so customers can message you instantly." },
      { title: "Website Maintenance", desc: "Hosting, updates, backups and technical support after launch." },
    ],
  },
  pricing: {
    eyebrow: "Pricing",
    title: "Professional Websites for Local Businesses",
    sub: "Get your business online with a professional website that helps customers discover your business, view your services, and contact you easily.",
    oneTime: "one-time",
    recommended: "Recommended",
    plans: [
      {
        name: "Launch",
        positioning: "Get Online",
        note: "For businesses that need a professional basic online presence.",
        tag: "One-time website setup",
        cta: "Get Started",
        features: [
          "Professional business website", "Mobile-friendly design", "Up to 5 pages",
          "Business information & services", "Photo gallery", "WhatsApp button",
          "Google Maps integration", "Contact/enquiry form", "Social media links",
          "SSL security", "Website setup & deployment", "1 year website hosting",
        ],
      },
      {
        name: "Business",
        positioning: "Grow Your Presence",
        note: "Best for businesses that want more than a basic online presence.",
        tag: "Everything in Launch +",
        cta: "Choose Business",
        features: [
          "Up to 8 pages", "Product/service catalogue", "Google Reviews section",
          "Enquiry/lead collection", "Basic SEO setup", "Google Business Profile assistance",
          "Additional customization", "2 rounds of content/design changes",
        ],
      },
      {
        name: "Business Pro",
        positioning: "Generate & Manage Enquiries",
        note: "Ideal for businesses that receive regular enquiries, bookings or appointments.",
        tag: "Everything in Business +",
        cta: "Go Pro",
        features: [
          "Online booking/appointment system", "Advanced enquiry management", "Customer lead dashboard",
          "Payment integration", "Automated enquiry notifications", "Advanced customization", "Priority support",
        ],
      },
    ],
    domainNote: "Domain registration is charged separately at actual cost. The domain is registered in your business name and belongs to you.",
    compareTitle: "Compare Packages",
    featureCol: "Feature",
    comparison: [
      ["Professional Website", true, true, true],
      ["Mobile Friendly", true, true, true],
      ["Number of Pages", "Up to 5", "Up to 8", "8+"],
      ["Photo Gallery", true, true, true],
      ["WhatsApp", true, true, true],
      ["Google Maps", true, true, true],
      ["Contact Form", true, true, true],
      ["Social Links", true, true, true],
      ["SSL", true, true, true],
      ["1 Year Hosting", true, true, true],
      ["Product/Service Catalogue", false, true, true],
      ["Google Reviews", false, true, true],
      ["Lead Collection", false, true, true],
      ["Basic SEO", false, true, true],
      ["Google Business Profile Assistance", false, true, true],
      ["Booking System", false, false, true],
      ["Lead Dashboard", false, false, true],
      ["Payment Integration", false, false, true],
      ["Automated Notifications", false, false, true],
      ["Priority Support", false, false, true],
    ],
    maintenance: {
      eyebrow: "From the Second Year",
      title: "Keep Your Website Running Smoothly",
      perYear: "/ year",
      features: ["Website hosting", "SSL", "Technical maintenance", "Website backups", "Minor content updates", "Website monitoring", "Technical support"],
      note: "Domain renewal is not included. Domain renewal will be charged separately at the registrar's actual renewal price. No compulsory monthly website subscription.",
    },
    optional: {
      eyebrow: "Optional Services",
      title: "Need Something More?",
      items: [
        { name: "Business Email", price: "From ₹999/year", note: "+ email provider charges" },
        { name: "Additional Website Pages", price: "₹499/page", note: "" },
        { name: "Additional Design / Customization", price: "Quoted based on requirement", note: "" },
        { name: "Website Content Writing", price: "From ₹999", note: "" },
        { name: "Logo Design", price: "From ₹999", note: "" },
      ],
      cta: "Enquire on WhatsApp",
    },
    trust: {
      title: "Simple Pricing. No Long-Term Commitment.",
      big: "Pay once. Get your website live.",
      body: "No compulsory monthly website subscription. Your domain remains registered in your business name, giving you ownership and control of your online identity.",
      clarification: "Domain registration and renewal are separate charges and are billed at the registrar's actual price.",
      cta: "Discuss Pricing on WhatsApp",
    },
  },
  steps: {
    eyebrow: "How It Works",
    title: "From First Chat to Live Website",
    sub: "A simple, guided process — no technical knowledge needed from your side.",
    stepLabel: "Step",
    items: [
      { title: "Tell Us About Your Business", desc: "Share what you do, your services and what your customers need to know." },
      { title: "Choose Your Website Style", desc: "Pick a look from our industry demos or tell us the style you like." },
      { title: "We Build Your Website", desc: "We design, write and set up your complete professional website." },
      { title: "Go Live & Start Sharing", desc: "Your website goes live. Share it on WhatsApp, Google and social media." },
    ],
    growPre: "Then —",
    growBold: "Grow With Us",
    growPost: ". Ongoing digital support whenever your business needs it.",
  },
  beforeAfter: {
    eyebrow: "Before vs After",
    title: "From Being Found to Being Trusted",
    without: "Without a Website",
    with: "With a Professional Website",
    withoutItems: [
      "Limited information",
      "Harder to showcase services",
      "Depends heavily on social media",
      "Less control over online presentation",
      "Competitors may look more professional",
    ],
    withItems: [
      "Clear business information",
      "Services/products presented professionally",
      "Easy WhatsApp and call enquiries",
      "Stronger digital presence",
      "Easy to share",
      "Available 24/7",
    ],
  },
  journey: {
    eyebrow: "The Customer Journey",
    title: "Turn Online Discovery Into a Real Conversation.",
    sub: "This is how a professional website turns a stranger searching on Google into your next customer.",
    steps: ["Google Search", "Business Website", "Trust", "WhatsApp / Call", "Enquiry", "Customer"],
  },
  benefits: {
    eyebrow: "Results That Matter",
    title: "What Your Website Can Do For Your Business",
    sub: "Customer stories coming soon — here's what a professional website is built to do for you.",
    cards: [
      { title: "Get Discovered", desc: "When people search for your services, your website gives them a professional place to land." },
      { title: "Build Trust", desc: "Your services, photos and business details presented professionally — before the first conversation." },
      { title: "Receive Enquiries", desc: "One-tap call and WhatsApp buttons make it effortless for customers to reach you." },
    ],
  },
  faq: {
    eyebrow: "FAQ",
    title: "Questions Business Owners Ask Us",
    sub: "Short, honest answers. Still unsure? WhatsApp us anytime.",
    items: [
      { q: "Why does my business need a website if I already have Instagram?", a: "Instagram is great for followers, but customers still search on Google before buying. A website is your own space — with your services, photos, prices and contact buttons — that you fully control." },
      { q: "I already have a Google Business Profile. Why do I need a website?", a: "A Google Business Profile helps people find you. A website convinces them to choose you — with full details, photos, services and easy enquiry buttons. They work best together." },
      { q: "Do I need technical knowledge?", a: "Not at all. We handle everything — design, setup, hosting and updates. You just tell us about your business." },
      { q: "Can customers contact me through WhatsApp?", a: "Yes. Every website we build includes one-tap WhatsApp and call buttons, so customers can reach you instantly." },
      { q: "Can you build a website specifically for my industry?", a: "Yes. We design websites for specific industries — restaurants, clinics, salons, tyre shops, builders and many more. Explore our demo showroom to see examples." },
      { q: "Can I see a demo before deciding?", a: "Absolutely. Browse the demo websites on this page, or WhatsApp us and we'll show you what your business website could look like." },
      { q: "Can my website be updated later?", a: "Yes. Your website can be updated anytime — new photos, services, prices or pages. Our packages include change rounds, and annual maintenance covers minor updates." },
      { q: "Do you help with domain and hosting?", a: "Yes. We set up everything. Your domain is registered in your business name and belongs to you. First-year hosting is included in every package." },
      { q: "How long does it take?", a: "Most business websites are ready within a few working days once we have your business details and photos. We'll confirm the timeline before we start." },
      { q: "Can you help me improve my online presence after the website is launched?", a: "Yes. From Google Business Profile support to content updates and new features — we continue supporting your digital growth after launch." },
    ],
  },
  about: {
    eyebrow: "About Disign Digital",
    title: "A Digital Growth Partner for Local Businesses",
    p1: "Disign Digital helps small and medium-sized local businesses build a professional digital presence — so customers can find them, trust them and contact them easily.",
    p2: "We believe every local business — from a tyre shop in Madurai to a boutique in Kochi — deserves the same quality of online presence as a big brand. Professional websites, honest pricing and support that continues after launch.",
    signature: "Anjum Kauser — Business Growth Expert at Disign Digital",
    valuesTitle: "What We Stand For",
    values: [
      { t: "Honest Pricing", d: "Pay once for your website. No compulsory monthly subscription." },
      { t: "Your Ownership", d: "Your domain is registered in your business name — it belongs to you." },
      { t: "Built for Local Business", d: "Simple, practical websites designed for real customers, not for show." },
      { t: "Support After Launch", d: "Hosting, updates and technical help so your website keeps working for you." },
    ],
  },
  contact: {
    eyebrow: "Contact",
    title: "Let's Build Your Digital Presence",
    sub: "Tell us about your business. We'll show you what your website could look like.",
    intro: "The easiest way to reach us is WhatsApp. Share your business name and city, and we'll take it from there.",
    whatsappLabel: "WhatsApp:",
    chat: "Chat on WhatsApp",
    requestDemo: "Request a Website Demo",
  },
  form: {
    name: "Name", namePh: "Your name",
    business: "Business Name", businessPh: "Your business name",
    phone: "Phone Number", phonePh: "Your WhatsApp number",
    city: "City", cityPh: "Your city",
    category: "Business Category", categoryPh: "Choose your business category",
    hasWebsite: "Do You Already Have a Website?", yes: "Yes", no: "No",
    need: "What Do You Need?", needPh: "Tell us briefly about your business and what you need",
    submit: "Request My Demo", sending: "Sending…",
    privacy: "We respect your privacy. Your details are only used to contact you about your website.",
    success: "Thank you! Anjum from Disign Digital will contact you shortly.",
    successSub: "Want a faster reply? Message us right now.",
    successCta: "Chat on WhatsApp",
    other: "Other",
  },
  finalCta: {
    title: "Ready to Put Your Business Online?",
    sub: "Tell us what you do. We'll show you what your business website could look like.",
    cta1: "Get My Website",
    cta2: "WhatsApp Anjum",
    small: "Anjum Kauser — Business Growth Expert at Disign Digital",
  },
  footer: {
    tagline: "Digital Presence. Real Business.",
    desc: "Professional websites for local businesses. Helping local businesses grow with a stronger digital presence.",
    explore: "Explore",
    contact: "Contact",
  },
  sticky: { whatsapp: "WhatsApp Us", getWebsite: "Get My Website" },
};
